export default "__VITE_ASSET__b29229c5__"